<div class="onboarding-form">
  <h1>Check your email</h1>
  <p class="fw-semibold text-muted mb-4">To continue please verify your email address.</p>
  <div class="h4 mb-4">{{ emailSentText }}</div>
  <app-resend-btn
    btnID="signupCheckEmailResendBtn"
    label="Resend email"
    (click)="emailResend()"
    (keydown)="emailResend()"
    [resend$]="resend$"></app-resend-btn>
  <app-router-switch-btn
    id="signupCheckEmailToLoginBtn"
    title="Login"
    urlLink="/login"></app-router-switch-btn>
</div>
